import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, reduxForm} from 'redux-form';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import buscarVeiculos from '../../actions/veiculo/buscarVeiculos'
import excluirItinerarios from '../../actions/itinerario/exclurItinerario';
import {alterouPagina} from '../../util/filtros';
import Itinerario from './Itinerario'
import ModalCadastrarItinerario from './ModalCadastrarItinerario';
import {alterouEmpresa} from '../../actions/empresa/alterarEmpresaSelecionada';
import buscarRotas from '../../actions/rota/buscarRotas';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import BotoesPaginacaoItinerario from './BotoesPaginacaoItinerario';
import PaginacaoItinerario from './PaginacaoItinerario';
import determinaPaginaAtual from '../../actions/itinerario/determinarPaginaAtualItinerario'
import limparItinerarios from '../../actions/itinerario/limparItinerarios'
import selecionarRota from '../../actions/rota/selecionarRota';
import buscarTiposPreco from '../../actions/preco/buscarTiposPreco';
import ModalCadastrarItinerarioPorPeriodo from './ModalCadastrarItinerarioPorPeriodo';
import ModalAlterarVeiculoItinerario from './ModalAlterarVeiculoItinerario';
import selecionarItinerario from '../../actions/itinerario/selecionarItinerario';
import ModalLocalizacaoVeiculo from '../veiculo/ModalLocalizacaoVeiculo';
import {showSuccessMsg} from '../../util/messagesUtil';
import ModalAlteracaoTipoAjusteEmLote from './ModalAlteracaoTipoAjusteItinerarioEmLote';
import ModalAlteracaoVeiculoItinerarioEmLote from './ModalAlteracaoVeiculoItinerarioEmLote';
import ModalAlteracaoTipoPrecoItinerarioEmLote from './ModalAlteracaoTipoPrecoItinerarioEmLote';
import ModalHabilitarVendasEmLoteNoSite from './ModalHabilitarVendasEmLoteNoSite';
import { inativarItinerario } from '../../actions/itinerario/ativarOuInativarItinerario';
import ModalAlteracaoPrestadorItinerarioEmLote from './ModalAlteracaoPrestadorItinerarioEmLote';
import ModalBloquearItinerarioPorCidadeEmLote from './ModalBloquearItinerarioPorCidadeEmLote';
import ModalPrecosRota from '../rota/ModalPrecosRota';
import {inativarVendaSite} from '../../actions/itinerario/ativarOuInativarVendaSite'
import { tipoCategoria } from '../../util/constantsUtil';
import limparVeiculoItinerarioSelecionado from '../../actions/itinerario/limparVeiculoItinerarioSelecionado';
import ModalHistoricoItinerario from './ModalHistoricoItinerario';
import ModalHistoricoTransferenciaPassageiro from './ModalHistoricoTransferenciaPassageiro';
import limparHistoricosTranferenciasPassageiros from '../../actions/itinerario/limparHistoricosTranferenciasPassageiros';
import limparUsuariosVendedores from '../../actions/usuario/limparUsuariosVendedores';
import ModalBloquearUsuarioEmpresaItinerarioPorEmLote from './ModalBloquearUsuarioEmpresaItinerarioPorEmLote';

export const CabecalhoTabela = ({habilitadoSite}) => (
    <div className={`vx-gp-table-header vx-gp-table-header--itinerario${habilitadoSite ? '-site' : ''} d-none d-lg-grid`}>
        <div>Data/Hora Saída</div>
        <div>Assentos</div>
        <div>Veículo</div>
        <div>Rota / IDs</div>
        <div>Prestador</div>
        {habilitadoSite && <div>Venda Site</div>}
        <div>Categorias</div>
        <div>Horário Extra</div>
        <div>Ativo/Inativo</div>
        <div>QR Embarque</div>
        <div>Ações</div>
    </div>
);

const ModalConfirmacaoInativacaoItinerario = ({ inativar, limpar }) => (
    <div className="modal fade" id="modalConfirmacaoInativacaoItinerario" tabIndex="-1" role="dialog" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content vx-modal-content">
                <div className="vx-modal-header">
                    <div className="vx-modal-header-left">
                        <i className="material-icons" style={{ color: '#FF6A00' }}>power_settings_new</i>
                        <span className="vx-modal-title">Inativar Itinerário</span>
                    </div>
                    <button type="button" className="vx-modal-close" data-dismiss="modal" onClick={() => limpar()}>
                        <i className="material-icons">close</i>
                    </button>
                </div>
                <div className="vx-modal-body" style={{ textAlign: 'center', padding: '24px' }}>
                    <p style={{ margin: 0 }}>Confirmar inativação do itinerário?</p>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-btn-secondary" data-dismiss="modal" onClick={() => limpar()}>Cancelar</button>
                    <button type="button" className="vx-btn-danger" data-dismiss="modal" onClick={() => inativar()}>Desativar</button>
                </div>
            </div>
        </div>
    </div>
);

const ModalConfirmacaoExclusaoItinerario = ({ excluir, limpar }) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoItinerario" tabIndex="-1" role="dialog" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content vx-modal-content">
                <div className="vx-modal-header">
                    <div className="vx-modal-header-left">
                        <i className="material-icons" style={{ color: '#dc2626' }}>delete</i>
                        <span className="vx-modal-title">Excluir Itinerário</span>
                    </div>
                    <button type="button" className="vx-modal-close" data-dismiss="modal" onClick={() => limpar()}>
                        <i className="material-icons">close</i>
                    </button>
                </div>
                <div className="vx-modal-body" style={{ textAlign: 'center', padding: '24px' }}>
                    <p style={{ margin: 0 }}>Deseja excluir o itinerário selecionado?</p>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-btn-secondary" data-dismiss="modal" onClick={() => limpar()}>Cancelar</button>
                    <button type="button" className="vx-btn-danger" data-dismiss="modal" onClick={() => excluir()}>Excluir</button>
                </div>
            </div>
        </div>
    </div>
);

const ModalConfirmacaoInativacaoVendaSite = ({ inativarVendaSite, limpar }) => (
    <div className="modal fade" id="modalConfirmacaoInativacaoVendaSite" tabIndex="-1" role="dialog" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content vx-modal-content">
                <div className="vx-modal-header">
                    <div className="vx-modal-header-left">
                        <i className="material-icons" style={{ color: '#FF6A00' }}>public</i>
                        <span className="vx-modal-title">Inativar Venda no Site</span>
                    </div>
                    <button type="button" className="vx-modal-close" data-dismiss="modal" onClick={() => limpar()}>
                        <i className="material-icons">close</i>
                    </button>
                </div>
                <div className="vx-modal-body" style={{ textAlign: 'center', padding: '24px' }}>
                    <p style={{ margin: 0 }}>Confirmar inativação para vendas no site do itinerário?</p>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-btn-secondary" data-dismiss="modal" onClick={() => limpar()}>Cancelar</button>
                    <button type="button" className="vx-btn-danger" data-dismiss="modal" onClick={() => inativarVendaSite()}>Desativar</button>
                </div>
            </div>
        </div>
    </div>
);

export class Itinerarios extends React.Component {
    constructor(props) {
        super(props);
        this.limparCampos = this.limparCampos.bind(this);
        this.excluir = this.excluir.bind(this);
        this.state = {
            itinerarioSelecionado: null,
            textoFiltro: null,
            rotaSelecionada: null,
            dataPartidaSelecionada: null,
            motoristasSelecionados: [],
            usuarioEmpresaBloqueioSelecionados: [],
            trechosSelecionados: [],
            cidadesSelecionadas: [],
            trechosBloqueioDescontoSelecionados: [],
            codigoItinerarioChecked: null,
            exibeTipoCategoriaUnica: true,
            vendedoresSelecionados: [],
            categoriasSelecionadas: []
        };
    }


    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps)) {
            this.props.limparItinerarios();
            if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
                this.props.buscarRotas(this.props.empresaSelecionada.id);
                this.props.buscarVeiculos(this.props.empresaSelecionada.id);
                this.props.limparUsuariosVendedores();
            }
            this.props.selecionarRota([]);
        }
        if (alterouPagina(this.props, prevProps)) {
            this.props.buscarItinerarios();
        }
    }

    itinerarioChecked(codigoItinerarioClicado) {
        this.setState({ codigoItinerarioChecked:  codigoItinerarioClicado })
    }

    limparDadosModal() {
        this.setState({ codigoItinerarioChecked: null });
    }

    limparSelecionarItinerario(){
        this.props.selecionarItinerario(null);
    }

    inativar() {
        this.props.inativarItinerario(this.props.empresaSelecionada.id, this.state.codigoItinerarioChecked)
                .then(()=>{
                    this.props.buscarItinerarios();
                });
    }

    inativarVendaSite() {
        this.props.inativarVendaSite(this.props.empresaSelecionada.id, this.state.codigoItinerarioChecked)
                .then(()=>{
                    this.props.buscarItinerarios();
                });
    }

    excluir() {
        this.props.excluirItinerarios(this.props.itinerarioSelecionado.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Itinerário excluido com sucesso.');
                this.props.buscarItinerarios();
                this.props.selecionarItinerario(null);
            })
    }

    limparCampos() {
        this.props.reset('formularioCadastroItinerario');
        this.limparMotoristasSelecionados();
        this.limparUsuarioEmpresaBloqueioSelecionados();
        this.limparTrechosSelecionados();
        this.limparCidadesSelecionadas();
        this.handleCheckedTipoCategoriaUnica(true);
        this.props.limparVeiculoItinerarioSelecionado();
        this.props.selecionarItinerario(null);
        this.props.limparItinerarios()
        this.props.limparHistoricosTranferenciasPassageiros();
    }


    exibirTabelaItinerariosEdicao() {
        if (this.props.itinerarios && this.props.itinerarios.length) {
            return (
                <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoItinerario}
                                       BotoesPaginacao={BotoesPaginacaoItinerario}
                                       itinerarios={this.props.itinerarios}
                                       empresaSelecionada={this.props.empresaSelecionada}>
                    <CabecalhoTabela habilitadoSite={this.props.empresaSelecionada.habilitadoSite}/>
                    {this.exibirItinerarios()}
                </CabecalhoRodapeTabela>
            );
        }
        return <div className="vx-gp-empty">Nenhum itinerário disponível.</div>;
    }

    exibirTabelaItinerarios() {
        if (this.props.itinerarios && this.props.itinerarios.length) {
            return (
                <React.Fragment>
                    <CabecalhoTabela habilitadoSite={this.props.empresaSelecionada.habilitadoSite}/>
                    {this.exibirItinerarios()}
                </React.Fragment>
            );
        }
        return <div className="vx-gp-empty">Nenhum itinerário disponível.</div>;
    }

    exibirItinerarios() {
        if (this.props.itinerarios) {
            return this.props.itinerarios
                .map((itinerario, index) => <Itinerario key={index}
                                                        isEdicao={this.props.isEdicao}
                                                        preencherModalEdicao={this.preencherModalEdicao.bind(this)}
                                                        buscarItinerarios={this.props.buscarItinerarios}
                                                        itinerario={itinerario}
                                                        itinerarioChecked={this.itinerarioChecked.bind(this)}
                                                        indice={index}
                                                        preencherPricePorUsuario={this.preencherPricePorUsuario.bind(this)}
                                                        preencherPricePorCategoria={this.preencherPricePorCategoria.bind(this)}
                                                        />)
        }
    }

    selecionarData(data) {
        this.setState({dataPartidaSelecionada: data});
        this.props.buscarItinerarios();
    }

    exibirCalendario() {
        if (this.props.rotaSelecionada && this.props.rotaSelecionada.value) {
            return (
                <React.Fragment>
                    <div style={{height: 38}}>
                        <DatePicker
                            className='form-control form-control-lg campo-busca data-itinerario'
                            locale="pt-BR"
                            value={this.state.dataPartidaSelecionada}
                            selected={this.state.dataPartidaSelecionada}
                            onChange={date => this.selecionarData(date)}
                            dateFormat="dd/MM/yyyy"
                            withPortal
                        />
                    </div>
                    {this.exibirLimparDataPartidaSelecionada()}
                </React.Fragment>
            )
        }
    }

    selecionarRota(rota) {
        this.setState({
            dataPartidaSelecionada: null
        });
        this.props.selecionarRota(rota);
        this.setState({trechos: this.props.rotas.filter(it => it.id === rota.value)[0].trechosDto});
        this.props.buscarItinerarios();
    }

    exibirLimparDataPartidaSelecionada() {
        if (this.state.dataPartidaSelecionada) {
            return <div>
                <i className="material-icons" style={{
                    marginLeft: 220,
                    position: 'absolute',
                    cursor: 'pointer',
                    top: 36,
                    color: 'red'
                }} onClick={() => this.selecionarData(null)}>&#xe5cd;</i>
            </div>
        }
    }

    exibirComboRotas(event) {
        if (this.props.rotas) {
            return (
                <div>
                    <Select
                        {...event.input}
                        noOptionsMessage={() => ('Nenhuma opção encontrada')}
                        placeholder='Selecione uma rota...'
                        options={this.props.rotas.map(elemento => (
                            {
                                label: `${elemento.prefixo ? elemento.prefixo : 'Prefixo não informado'}: ${elemento.cidadeOrigem.nome}-${elemento.cidadeOrigem.uf} -> ${elemento.cidadeDestino.nome}-${elemento.cidadeDestino.uf} / ${elemento.prestador ? elemento.prestador : 'Prestador não informado'}`,
                                value: elemento.id
                            }))}
                        onChange={value => this.selecionarRota(value)}
                        value={this.props.rotaSelecionada}
                    />
                    {event.meta.touched
                    && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
                </div>
            )
        }
        return '';
    }


    selecionarMotorista(motorista) {
        const motoristas = this.state.motoristasSelecionados;
        motoristas.push(motorista);
        this.setState({motoristasSelecionados: motoristas})
    }

    selecionarVendedorParaBloquear(vendedor) {
        const usuarios = this.state.usuarioEmpresaBloqueioSelecionados;
        usuarios.push(vendedor);
        this.setState({usuarioEmpresaBloqueioSelecionados: usuarios})
    }

    adicionarCidades(cidade){

        if(this.state.cidadesSelecionadas.filter(it => it.value === cidade.value).length ===  0){
            const cidadesSelecionadas = this.state.cidadesSelecionadas;
            cidadesSelecionadas.push(cidade);
            this.setState({cidadesSelecionadas: cidadesSelecionadas})
        }
    }

    adicionarTrechos(trechoOrigem, trechoDestino) {
        if (this.state.trechosSelecionados.filter(it => it.origem.value === trechoOrigem.value && it.destino.value === trechoDestino.value).length === 0) {
            const trechosSelecionados = this.state.trechosSelecionados;
            trechosSelecionados.push({origem: trechoOrigem, destino: trechoDestino});
            this.setState({trechosSelecionados: trechosSelecionados})
        }
    }

    adicionarPricePorUsuario(obj) {
        if(this.state.vendedoresSelecionados.filter(it => it.id === obj.id).length ===  0){
            const vendedores  = this.state.vendedoresSelecionados;        
            vendedores.push(obj);        
            this.setState({ vendedoresSelecionados: vendedores });
        }
    }

    preencherPricePorUsuario(vendedores) {
        this.setState({ vendedoresSelecionados: vendedores });
    }

    preencherPricePorCategoria(categorias) {
        this.setState({ categoriasSelecionadas: categorias });
    }
    
    adicionarTrechosBloqueioDesconto(trechoOrigem, trechoDestino) {
        if (this.state.trechosBloqueioDescontoSelecionados.filter(it => it.origem.value === trechoOrigem.value && it.destino.value === trechoDestino.value).length === 0) {
            const trechosSelecionados = this.state.trechosBloqueioDescontoSelecionados;
            trechosSelecionados.push({origem: trechoOrigem, destino: trechoDestino});
            this.setState({trechosBloqueioDescontoSelecionados: trechosSelecionados})
        }
    }

    handleCheckedTipoCategoriaUnica(valor) {
        if (valor) {
            this.setState({ exibeTipoCategoriaUnica: valor });
        } else {
            this.setState({ exibeTipoCategoriaUnica: !this.state.exibeTipoCategoriaUnica });
        }


    }


    preencherModalEdicao(itinerario) {
        if (itinerario && itinerario.motoristas) {
            this.setState({
                motoristasSelecionados: itinerario.motoristas.map(elemento => ({
                    label: elemento.nome,
                    value: elemento.usuarioEmpresaId
                }))
            })
        } else {
            this.setState({motoristasSelecionados: []})
        }

        if (itinerario && itinerario.usuariosEmpresaBloqueado) {
            this.setState({
                usuarioEmpresaBloqueioSelecionados: itinerario.usuariosEmpresaBloqueado.map(elemento => ({
                    label: elemento.nome,
                    value: elemento.id
                }))
            })
        } else {
            this.setState({usuarioEmpresaBloqueioSelecionados: []})
        }

        if (itinerario && itinerario.trechosBloqueados) {
            this.setState({
                trechosSelecionados: itinerario.trechosBloqueados.map(elemento => (
                    {
                        origem: {
                            label: elemento.trechoOrigem.valor,
                            value: elemento.trechoOrigem.chave
                        }, destino: {
                            label: elemento.trechoDestino.valor,
                            value: elemento.trechoDestino.chave
                        }
                    }

                ))
            })
        } else {
            this.setState({trechosSelecionados: []})
        }
        if (itinerario && itinerario.cidadesBloqueados) {
            this.setState({
                cidadesSelecionadas: itinerario.cidadesBloqueados.map(elemento => (
                    {
                        label: elemento.cidade.valor,
                        value: elemento.cidade.chave
                    }

                ))
            })
        } else {
            this.setState({cidadesBloqueados: []})
        }
        if (itinerario && itinerario.trechosBloqueadosDesconto) {
            this.setState({
                trechosBloqueioDescontoSelecionados: itinerario.trechosBloqueadosDesconto.map(elemento => (
                    {
                        origem: {
                            label: elemento.trechoOrigem.valor,
                            value: elemento.trechoOrigem.chave
                        }, destino: {
                            label: elemento.trechoDestino.valor,
                            value: elemento.trechoDestino.chave
                        }
                    }

                ))
            })
        } else {
            this.setState({trechosBloqueadosDesconto: []})
        }

        this.setState({ exibeTipoCategoriaUnica: itinerario.tipoCategoria === tipoCategoria.unica.valor });
    }

    removerMotorista(id) {
        this.setState({motoristasSelecionados: this.state.motoristasSelecionados.filter(it => it.value !== id)})

    }

    removerUsuarioEmpresaBloqueio(id) {
        this.setState({usuarioEmpresaBloqueioSelecionados: this.state.usuarioEmpresaBloqueioSelecionados.filter(it => it.value !== id)})

    }

    removerTrechoSelecionado(idOrigem, idDestino) {
        this.setState({trechosSelecionados: this.state.trechosSelecionados.filter(it => !(it.origem.value === idOrigem && it.destino.value === idDestino))})
    }

    removerCidadeSelecionada(idCidade) {
        this.setState({cidadesSelecionadas: this.state.cidadesSelecionadas.filter(it => !(it.value === idCidade))})
    }

    removerTrechoBloqueioDescontoSelecionado(idOrigem, idDestino) {
        this.setState({trechosBloqueioDescontoSelecionados: this.state.trechosBloqueioDescontoSelecionados.filter(it => !(it.origem.value === idOrigem && it.destino.value === idDestino))})
    }

    removerUsuarioVendedor(usuarioId) {
        this.setState({vendedoresSelecionados: this.state.vendedoresSelecionados.filter(it => !(it.id === usuarioId))})
    }

    limparMotoristasSelecionados() {
        this.setState({motoristasSelecionados: []})
    }

    limparUsuarioEmpresaBloqueioSelecionados() {
        this.setState({usuarioEmpresaBloqueioSelecionados: []})
    }

    limparTrechosSelecionados() {
        this.setState({trechosSelecionados: []})
    }
    limparCidadesSelecionadas(){
        this.setState({cidadesSelecionadas: []})
    }

    limparPricePorUsuario() {
        this.setState({ vendedoresSelecionados: []})
    }

    adicionarPricePorCategoria(obj) {
        if (this.state.categoriasSelecionadas.filter(it => it.tipoPreco === obj.tipoPreco).length === 0) {
            const categorias = this.state.categoriasSelecionadas;
            categorias.push(obj);
            this.setState({ categoriasSelecionadas: categorias });
        }
    }

    removerCategoriaSelecionada(tipoPreco) {
        this.setState({ categoriasSelecionadas: this.state.categoriasSelecionadas.filter(it => it.tipoPreco !== tipoPreco) });
    }

    limparPricePorCategoria() {
        this.setState({ categoriasSelecionadas: [] });
    }

    render() {
        return (
            <div>
                {this.props.isEdicao ? this.exibirTabelaItinerariosEdicao() : this.exibirTabelaItinerarios()}
                <ModalCadastrarItinerario limparCidadesSelecionadas={this.limparCidadesSelecionadas.bind(this)}
                                          removerCidadeSelecionada={this.removerCidadeSelecionada.bind(this)}
                                          cidadesSelecionadas={this.state.cidadesSelecionadas}
                                          adicionarCidades={this.adicionarCidades.bind(this)}
                                          buscarItinerarios={this.props.buscarItinerarios}
                                          dataPartida={this.state.dataPartidaSelecionada}
                                          selecionarMotorista={this.selecionarMotorista.bind(this)}
                                          selecionarVendedorParaBloquear = {this.selecionarVendedorParaBloquear.bind(this)}
                                          removerMotorista={this.removerMotorista.bind(this)}
                                          removerUsuarioEmpresaBloqueio={this.removerUsuarioEmpresaBloqueio.bind(this)}
                                          removerTrechoBloqueioDescontoSelecionado={this.removerTrechoBloqueioDescontoSelecionado.bind(this)}
                                          motoristasSelecionados={this.state.motoristasSelecionados}
                                          usuarioEmpresaBloqueioSelecionados={this.state.usuarioEmpresaBloqueioSelecionados}
                                          trechosSelecionados={this.state.trechosSelecionados}
                                          trechosBloqueioDescontoSelecionados={this.state.trechosBloqueioDescontoSelecionados}
                                          limparMotoristasSelecionados={this.limparMotoristasSelecionados.bind(this)}
                                          limparUsuarioEmpresaBloqueioSelecionados={this.limparUsuarioEmpresaBloqueioSelecionados.bind(this)}
                                          limparTrechosSelecionados={this.limparTrechosSelecionados.bind(this)}
                                          adicionarTrechos={this.adicionarTrechos.bind(this)}
                                          adicionarTrechosBloqueioDesconto={this.adicionarTrechosBloqueioDesconto.bind(this)}
                                          removerTrechoSelecionado={this.removerTrechoSelecionado.bind(this)}
                                          exibeTipoCategoriaUnica={this.state.exibeTipoCategoriaUnica}
                                          handleCheckedTipoCategoriaUnica={this.handleCheckedTipoCategoriaUnica.bind(this)}
                                          vendedoresSelecionados={this.state.vendedoresSelecionados}
                                          adicionarPricePorUsuario={this.adicionarPricePorUsuario.bind(this)}
                                          removerUsuarioVendedor={this.removerUsuarioVendedor.bind(this)}
                                          limparPricePorUsuario={this.limparPricePorUsuario.bind(this)}
                                          categoriasSelecionadas={this.state.categoriasSelecionadas}
                                          adicionarPricePorCategoria={this.adicionarPricePorCategoria.bind(this)}
                                          removerCategoriaSelecionada={this.removerCategoriaSelecionada.bind(this)}
                                          limparPricePorCategoria={this.limparPricePorCategoria.bind(this)} />
                <ModalCadastrarItinerarioPorPeriodo limparCidadesSelecionadas={this.limparCidadesSelecionadas.bind(this)}
                                                    removerCidadeSelecionada={this.removerCidadeSelecionada.bind(this)}
                                                    cidadesSelecionadas={this.state.cidadesSelecionadas}
                                                    adicionarCidades={this.adicionarCidades.bind(this)}
                                                    buscarItinerarios={this.props.buscarItinerarios}
                                                    dataPartida={this.state.dataPartidaSelecionada}
                                                    trechosSelecionados={this.state.trechosSelecionados}
                                                    trechosBloqueioDescontoSelecionados={this.state.trechosBloqueioDescontoSelecionados}
                                                    limparUsuarioEmpresaBloqueioSelecionados={this.limparUsuarioEmpresaBloqueioSelecionados.bind(this)}
                                                    removerTrechoSelecionado={this.removerTrechoSelecionado.bind(this)}
                                                    removerTrechoBloqueioDescontoSelecionado={this.removerTrechoBloqueioDescontoSelecionado.bind(this)}
                                                    limparTrechosSelecionados={this.limparTrechosSelecionados.bind(this)}
                                                    selecionarMotorista={this.selecionarMotorista.bind(this)}
                                                    selecionarVendedorParaBloquear = {this.selecionarVendedorParaBloquear.bind(this)}
                                                    removerMotorista={this.removerMotorista.bind(this)}
                                                    removerUsuarioEmpresaBloqueio={this.removerUsuarioEmpresaBloqueio.bind(this)}
                                                    adicionarTrechos={this.adicionarTrechos.bind(this)}
                                                    adicionarTrechosBloqueioDesconto={this.adicionarTrechosBloqueioDesconto.bind(this)}
                                                    motoristasSelecionados={this.state.motoristasSelecionados}
                                                    usuarioEmpresaBloqueioSelecionados={this.state.usuarioEmpresaBloqueioSelecionados}
                                                    limparMotoristasSelecionados={this.limparMotoristasSelecionados.bind(this)}
                                                    vendedoresSelecionados={this.state.vendedoresSelecionados}
                                                    adicionarPricePorUsuario={this.adicionarPricePorUsuario.bind(this)}
                                                    removerUsuarioVendedor={this.removerUsuarioVendedor.bind(this)}
                                                    limparPricePorUsuario={this.limparPricePorUsuario.bind(this)}
                                                    categoriasSelecionadas={this.state.categoriasSelecionadas}
                                                    adicionarPricePorCategoria={this.adicionarPricePorCategoria.bind(this)}
                                                    removerCategoriaSelecionada={this.removerCategoriaSelecionada.bind(this)}
                                                    limparPricePorCategoria={this.limparPricePorCategoria.bind(this)}/>
                <ModalAlteracaoTipoAjusteEmLote buscarItinerarios={this.props.buscarItinerarios}
                  vendedoresSelecionados={this.state.vendedoresSelecionados}
                  adicionarPricePorUsuario={this.adicionarPricePorUsuario.bind(this)}
                  removerUsuarioVendedor={this.removerUsuarioVendedor.bind(this)}
                  limparPricePorUsuario={this.limparPricePorUsuario.bind(this)}
                  categoriasSelecionadas={this.state.categoriasSelecionadas}
                  adicionarPricePorCategoria={this.adicionarPricePorCategoria.bind(this)}
                  removerCategoriaSelecionada={this.removerCategoriaSelecionada.bind(this)}
                  limparPricePorCategoria={this.limparPricePorCategoria.bind(this)}/>
                <ModalAlteracaoVeiculoItinerarioEmLote buscarItinerarios={this.props.buscarItinerarios}/>
                <ModalBloquearUsuarioEmpresaItinerarioPorEmLote buscarItinerarios={this.props.buscarItinerarios}/>
                <ModalAlteracaoPrestadorItinerarioEmLote buscarItinerarios={this.props.buscarItinerarios}/>
                <ModalAlteracaoTipoPrecoItinerarioEmLote buscarItinerarios={this.props.buscarItinerarios}/>
                <ModalHabilitarVendasEmLoteNoSite buscarItinerarios={this.props.buscarItinerarios} />
                <ModalConfirmacaoExclusaoItinerario excluir={this.excluir} limpar={this.limparSelecionarItinerario.bind(this)}/>
                <ModalAlterarVeiculoItinerario buscarItinerarios={this.props.buscarItinerarios} />
                <ModalLocalizacaoVeiculo/>
                <ModalConfirmacaoInativacaoItinerario inativar={this.inativar.bind(this)} limpar={this.limparDadosModal.bind(this)} />
                <ModalConfirmacaoInativacaoVendaSite inativarVendaSite={this.inativarVendaSite.bind(this)} limpar={this.limparDadosModal.bind(this)} />
                <ModalBloquearItinerarioPorCidadeEmLote
                                                    trechosSelecionados={this.state.trechosSelecionados}
                                                    buscarItinerarios={this.props.buscarItinerarios}/>
                <ModalPrecosRota painelGerencial='itinerario' />
                <ModalHistoricoItinerario />
                <ModalHistoricoTransferenciaPassageiro />
            </div>
        )
    }
}

export const mapStateToProps = state => (
    {
        itinerarios: state.itinerarios.itinerarios,
        veiculos: state.veiculos.veiculos,
        rotas: state.rotas.rotas,
        changeFieldValue,
        empresaSelecionada: state.empresaSelecionada,
        paginaAtual: state.paginaAtualItinerario,
        registrosPorPagina: state.registrosPorPaginaItinerario,
        itinerarioSelecionado: state.itinerarioSelecionado,
        rotaSelecionada: state.rotaSelecionada,
        filtrosAdicionados: state.filtrosAdicionadosItinerario,

    });


export default connect(mapStateToProps,
    {
        excluirItinerarios,
        buscarRotas,
        buscarVeiculos,
        determinaPaginaAtual,
        selecionarRota,
        limparItinerarios,
        buscarTiposPreco,
        selecionarItinerario,
        inativarItinerario,
        inativarVendaSite,
        limparVeiculoItinerarioSelecionado,
        limparHistoricosTranferenciasPassageiros,
        limparUsuariosVendedores
    })(reduxForm({
    form: 'formularioCadastroItinerario'
})(Itinerarios))
